import { surveyPlugin } from "survey-vue3-ui";
import { boot } from "quasar/wrappers";

export default boot(({ app }) => {
  app.use(surveyPlugin);
});
